// axios封装
import axios from 'axios';
import {Loading, Message} from 'element-ui';
import store from '../store';
import router from '../router';
import apiConfig from './api.config';
import storeJs from "storejs";

//let saveNewOrModifyModule; // 记录请求的模块
let loadingInstance; // loading
let isAuth = false;
let isLoading = true;
let isTips=false;

axios.defaults.baseURL = apiConfig.baseUrl;
//axios.defaults.baseURL = '/pc';

// 请求超时时间
// axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截器
axios.interceptors.request.use(
    (config) => {

        isAuth = config.url === "passport/authorization";

        config.headers.Identity = store.state.identity;
        config.headers.Authorization = store.state.token;
        return config;
    },
    error => Promise.error(error),
);

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        //let res_data = {};
        const {data = {}} = response;
        const {ret, msg} = data;

        // 如果有模块A发起保存请求成功（意味着新建或修改），将模块A名称记录进map
        // 用于下次进入其他模块（比如：模块B）时，如果模块B内有调用模块A的请求数据接口，则触发请求，
        // if (saveNewOrModifyModule) {
        //     store.commit('setRefreshDataMap', {key: saveNewOrModifyModule});
        // }

        if (!isAuth) {
            if (ret === 4456) {
                storeJs.remove('token');
                storeJs.remove('userInfo');
                store.state.token = '';
                router.push({name: 'login'});
            }

            if (ret > 1000){
                //if(isTips){
                    Message.error(msg);
                //}

            }
        }

        if (isLoading){
            // 关闭loading
            loadingInstance.close();
        }

        console.log(data);
        // return data;
        return Promise.resolve(data);
    },
    // 服务器状态码不是200的情况
    (error) => {
        console.log('error',error);
        const {response} = error;
        //const {status, data = {}} = response || {};

        // 关闭loading
        if (isLoading) {
            loadingInstance.close();
        }

        Message.error('服务器出错');

        // switch (status) {
        //     case 401:
        //         // 未登录或过期
        //         router.push({name: 'login'});
        //         break;
        //     case 404:
        //         Message.error('服务器出错');
        //         // Toast.fail('服务器出错');
        //         break;
        //     default:
        //         Message.error(data.message || '服务器出错');
        //         // Toast.fail(data.message || '服务器出错');
        // }
        // return response;
        return Promise.reject(response);
    },
);

/**
 * 请求方法封装，主要是为了新增或者修改的接口请求成功后，生成一个记录，其他页面根据此记录来决定数据是否需要刷新
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {boolean} loading - 是否显示加载状态
 * @return {object} - 查找结果
 */

// get方法
export function get(url, params, loading,isShowTips) {
    isLoading = loading;
    isTips=isShowTips;
    // saveNewOrModifyModule = module;

    // 加载loading
    if (loading) {
        loadingInstance = Loading.service({background: 'rgba(0,0,0,0.5)'});
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {params})
            .then((res) => {
                resolve(res,isTips);
            }).catch((err = {}) => {
            reject(err);
        });
    });
}
/**
 * 请求方法封装，主要是为了新增或者修改的接口请求成功后，生成一个记录，其他页面根据此记录来决定数据是否需要刷新
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {boolean} loading - 是否显示加载状态
 * @return {object} - 查找结果
 */
// post方法
export function post(url, params, loading,isShowTips) {
    isLoading = loading;
    // saveNewOrModifyModule = module;
    isTips=isShowTips;

    // 加载loading
    if (loading) {
        loadingInstance = Loading.service({background: 'rgba(0,0,0,0.5)'});
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params).then((res) => {
            resolve(res);
        }).catch((err = {}) => {
            reject(err);
        });
    });
}
